<div class="layout-footer">
    <div>
        <img [src]="darkMode ? 'assets/layout/images/humensis_logo_darkmod.png' : 'assets/layout/images/humensis_logo.jpg'" alt="roma-layout"/>
        <p></p>
    </div>
    <div class="footer-icons">
        <!-- <button class="p-link">
            <i class="pi pi-home"></i>
        </button>
        <button class="p-link">
            <i class="pi pi-globe"></i>
        </button>
        <button class="p-link">
            <i class="pi pi-envelope"></i>
        </button> -->
    </div>
</div>
